import React from 'react';
import { ROOT_PAGE } from 'constants/pages';
import Alert from 'svg/Alert';
import { ButtonLink } from 'components/Button';
import Modal from 'components/modals/Modal';

interface ModalActivateCoachAccountProps {
  isOpen: boolean;
  handleClose: () => void;
}

const ModalActivateCoachAccount: React.FC<ModalActivateCoachAccountProps> = ({
  isOpen,
  handleClose,
}) => {
  return (
    <Modal isOpen={isOpen} handleClose={handleClose} classNameMaxWidth="max-w-[40rem]">
      <div className="flex flex-col pt-[4.75rem]">
        <div className="flex flex-col items-center px-10 pb-16">
          <div className="h-30 w-30 mb-8">
            <Alert />
          </div>

          {/* Text content */}
          <div className="flex flex-col items-center gap-6 text-center">
            <h2 className="typography-product-display text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
              Please activate your account
            </h2>
            <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
              To protect coaches and players from spam, we require basic account information before
              accessing more features.
            </p>
          </div>
        </div>

        {/* Modal footer */}
        <div className="flex h-24 items-center justify-end px-6 py-5">
          <ButtonLink
            href={ROOT_PAGE}
            variant="primary"
            size="lg"
            className="w-full"
            onClick={handleClose}
          >
            Back to Account setup
          </ButtonLink>
        </div>
      </div>
    </Modal>
  );
};

export default ModalActivateCoachAccount;
